import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Switch } from '@/components/ui/switch';
import { RootState } from '../../types/graph';

export const Queue = () => {
  const [showEmpty, setShowEmpty] = useState(true);

  const sectionQueues = useSelector(
    (state: RootState) => state.questionnaire.sectionQueues,
  );
  const pages = useSelector(
    (state: RootState) => state.questionnaire.config?.pages,
  );

  const pageEntries = pages ? Object.entries(pages) : [];

  return (
    <div className="bg-[var(--dbg-bg)] p-2 flex flex-col gap-2">
      <label className="flex items-center gap-2 px-1">
        <Switch checked={showEmpty} onCheckedChange={setShowEmpty} />
        <span className="text-[var(--dbg-text-secondary)] text-xs py-2">
          {showEmpty ? 'Masquer' : 'Afficher'} les sections vides
        </span>
      </label>
      {pageEntries.map(([pageName, page]) => {
        const filteredSections = page.sections.filter(
          (section) => showEmpty || (sectionQueues[section] || []).length > 0,
        );

        if (filteredSections.length === 0) return null;

        return (
          <div key={pageName}>
            <div className="text-[var(--dbg-text)] font-bold text-xs uppercase tracking-wide mb-1 px-1 ">
              {pageName}
            </div>
            <div className="flex flex-col gap-1 ">
              {filteredSections.map((section) => {
                const questionIds = sectionQueues[section] || [];
                const borderColor =
                  questionIds.length === 0
                    ? 'border-gray-400'
                    : questionIds.length === 1
                    ? 'border-amber-400'
                    : 'border-blue-400';
                return (
                  <div
                    key={section}
                    className={`bg-[var(--dbg-bg-secondary)] border-l-4 ${borderColor} rounded p-3 ml-2 `}
                  >
                    <div className="text-[var(--dbg-text-secondary)] font-semibold text-xs mb-2">
                      {section} ({questionIds.length})
                    </div>
                    <div className="flex flex-wrap gap-1 items-center">
                      {questionIds.map((extId, j) => (
                        <span key={j}>
                          <span className="text-[var(--dbg-text)] font-mono text-xs">
                            {extId}
                          </span>
                          {j < questionIds.length - 1 && (
                            <span className="text-[var(--dbg-text-secondary)] mx-1">
                              →
                            </span>
                          )}
                        </span>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
